import { Globe, Briefcase, TrendingUp, Cpu } from "lucide-react";

interface AboutUsProps {
  language: 'en' | 'de';
}

export const AboutUs = ({ language }: AboutUsProps) => {
  const content = {
    en: {
      title: "About us",
      subtitle: "Delivering excellence across borders",
      stats: [
        {
          icon: TrendingUp,
          value: "20+",
          label: "Years of experience"
        },
        {
          icon: Briefcase,
          value: "100+",
          label: "Projects delivered"
        },
        {
          icon: Globe,
          value: "17",
          label: "Countries served"
        },
        {
          icon: Cpu,
          value: "1200",
          label: "Trillion operations per second in own lab"
        }
      ],
      mapTitle: "International project experience",
      countries: [
        "USA", "Mexico", "Brazil", "UK", "France", "Denmark", "Lithuania",
        "Liechtenstein", "Germany", "Austria", "Switzerland", "Hungary",
        "Slovenia", "Czech Republic", "Poland", "Romania", "China"
      ]
    },
    de: {
      title: "Über uns",
      subtitle: "Exzellenz über Grenzen hinweg",
      stats: [
        {
          icon: TrendingUp,
          value: "20+",
          label: "Jahre Erfahrung"
        },
        {
          icon: Briefcase,
          value: "100+",
          label: "Projekte umgesetzt"
        },
        {
          icon: Globe,
          value: "17",
          label: "Länder bedient"
        },
        {
          icon: Cpu,
          value: "1200",
          label: "Billionen Operationen pro Sekunde im eigenen Labor"
        }
      ],
      mapTitle: "Internationale Projekterfahrung",
      countries: [
        "USA", "Mexiko", "Brasilien", "UK", "Frankreich", "Dänemark", "Litauen",
        "Liechtenstein", "Deutschland", "Österreich", "Schweiz", "Ungarn",
        "Slowenien", "Tschechische Republik", "Polen", "Rumänien", "China"
      ]
    }
  };

  const currentContent = content[language];

  return (
    <section id="about-us" className="py-20 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            {currentContent.title}
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            {currentContent.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {currentContent.stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div
                key={index}
                className="group p-8 rounded-2xl bg-card border border-border hover:border-accent/50 transition-smooth hover:shadow-elegant text-center"
              >
                <div className="mb-6 p-4 rounded-lg bg-accent/10 w-fit mx-auto group-hover:bg-accent/20 transition-smooth">
                  <Icon className="w-8 h-8 text-accent" />
                </div>
                <div className="text-5xl font-bold mb-2 text-accent">
                  {stat.value}
                </div>
                <div className="text-lg text-muted-foreground">
                  {stat.label}
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};
